declare global {
  /**
 *
 *
 */
  /*                                                             */
  interface OttoComponents {}

  interface Window {
    /**
 *
 *
 */
    o_components: OttoComponents;
  }
}

window.o_components ||= {} as OttoComponents;

/*                                 */
export const { o_components: components } = window;
